<template>
    <sa-page-layout :btnBackVisible="true" :linkback="linkback" :linkedit="linkedit" :pathResource="pathResource" :showModalLoading="showModalLoading">
        <template slot="toolbar-title">
            <rsa-ospite-anagrafica-component :jsonData="jsonData" />
        </template>

        <template slot="table-body">
            <rsa-paziente-storico-stati-component ref="cmpStoricoStatiComponent" />
        </template>
    </sa-page-layout>
</template>

<script>
import axios from "axios";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaOspiteAnagraficaComponent from "../../rsagestioneospiti/components/RsaOspiteAnagraficaComponent.vue";

import RsaPazienteStoricoStatiComponent from "../components/RsaPazienteStoricoStatiComponent.vue";

export default {
    props: {
        utente: { type: Object },
    },

    components: {
        SaPageLayout,
        RsaOspiteAnagraficaComponent,
        RsaPazienteStoricoStatiComponent,
    },

    data() {
        return {
            idAccettazione: null,
            linkedit: null,
            linkback: "/rsagestioneospiti",
            showModalLoading: false,
            pathResource: null,

            pathResourceAccettazione: "/accettazioni",

            jsonData: {
                accettazioneAnagrafica: {},
                accettazionePrestazioni: {},
                accettazioneStati: [],
                accettazioneStruttura: {},
                accettazionePresidio: {},
            },
        };
    },

    mounted() {
        this.idAccettazione = this.$route.query.idAccettazione;
        this.loadAccettazione();
    },

    methods: {
        loadAccettazione() {
            this.showModalLoading = true;
            const link = process.env.VUE_APP_PATH_API + this.pathResourceAccettazione + "/" + this.idAccettazione;
            axios
                .get(link)
                .then((response) => {
                    this.jsonData = response.data.data;
                    this.$refs.cmpStoricoStatiComponent.init(this.jsonData);
                    this.showModalLoading = false;
                })
                .catch(() => {
                    this.showModalLoading = false;
                });
        },
    },
};
</script>
